export default "/images/vendor/lightbox2/src/close.png?0cfd6489536ec0987466795401497368";